<div class="page_title_content">
    <div class="page_title">{{'DEMONSTRATIONS_VALIDATION_CODE.TITLE' | translate}}</div>
</div>

<form [formGroup]="this.validationCodeForm" (ngSubmit)="this.validateByCode()">
    <demooz-input type="text" label="{{'DEMONSTRATIONS_VALIDATION_CODE.CODE' | translate}}" formName="code" [fixedLabel]="true"/>  
    <demooz-button type="submit" id="button_validate_demo_by_code" label="{{'DEMONSTRATIONS_VALIDATION_CODE.BUTTON_VALIDATE' | translate}}" [fullSize]="true" [isFetching]="this.isFetchingValidate"/>      
</form>